import styled from "styled-components";
import { remCalc } from "../theme/style-utils-coras-nua";
import { Tooltip } from "reactstrap";
import defaultTheme from "../theme/theme-test-override";

const StyledBoiTooltip = styled("div")`
    width: ${remCalc(36)};
    display: inline;
    white-space: nowrap;
    button {
        padding: ${remCalc(1)} ${remCalc(5)};
        min-width: auto;
        display: inline-flex;
        top: ${remCalc(2)};
        position: relative;
        margin: 0;
        width: ${remCalc(16)};
        height: ${remCalc(16)};
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill-rule='evenodd'%3E%3Cpath fill='%23fff' d='M-528-762H752v5087H-528z'/%3E%3Cpath d='M8 1.333c1.768 0 3.464.702 4.714 1.953S14.667 6.232 14.667 8A6.67 6.67 0 0 1 8 14.667 6.67 6.67 0 0 1 1.333 8 6.67 6.67 0 0 1 8 1.333zm1 5.333H7c-.184 0-.333.149-.333.333s.149.333.333.333h.25v4H7c-.184 0-.333.149-.333.333S6.816 12 7 12h2c.184 0 .333-.149.333-.333s-.149-.333-.333-.333h-.25v-4H9c.184 0 .333-.149.333-.333S9.184 6.667 9 6.667zm-1-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z' fill='%23161616' fill-rule='nonzero'/%3E%3C/svg%3E");
    }
`;

const StyledTooltip = styled(Tooltip)`
    .tooltip {
        position: absolute;
        z-index: 1070;
        display: block;
        margin: 0;
        font-size: ${remCalc(14)};
        line-height: ${remCalc(22)};
        // Allow breaking very long words so they don't overflow the tooltip's bounds
        word-wrap: break-word;
        opacity: 0;
        a,
        a:hover {
            color: ${props => props.theme.colors.brilliant};
            &[target="_blank"]:after {
                background-image: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg  viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3Ee%3C/title%3E %3Cg id='Templates' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M5.0824769,12.0015612 C5.16844471,12.0015612 5.28743246,11.9521533 5.34810126,11.8912404 L13.8543371,3.38469938 L15.3608948,4.89095189 C15.421411,4.95097983 15.5397274,4.99968577 15.6249627,4.99968577 C15.8317799,4.99968577 15.9997787,4.83183949 15.9999619,4.62502235 L15.9999619,0.375032485 C15.9999619,0.168032246 15.831963,3.33786011e-05 15.6249627,3.33786011e-05 L11.3749729,3.33786011e-05 C11.1681557,0.000216483633 11.0003095,0.168215351 11.0003095,0.375032485 C11.0003095,0.460695122 11.0494427,0.579408218 11.1099589,0.640046501 L12.6159062,2.14660419 L4.10967038,10.6528095 C4.04878795,10.7134783 3.99938011,10.8324966 3.99938011,10.9184339 C3.99938011,11.0044017 4.04878795,11.1233894 4.10967038,11.1840582 L4.81685253,11.8912404 C4.87752133,11.9521533 4.9965396,12.0015612 5.0824769,12.0015612 Z M12.4999702,15.9999952 C13.3279712,15.9999952 13.9999666,15.3279998 13.9999666,14.4999988 L13.9999666,9.50001073 C13.9999666,9.22401041 13.7759681,9.00001192 13.4999678,9.00001192 L12.999969,9.00001192 C12.7239687,9.00001192 12.4999702,9.22401041 12.4999702,9.50001073 L12.4999702,14.3124993 C12.4999702,14.4159841 12.4159555,14.4999988 12.3124706,14.4999988 L1.68749598,14.4999988 C1.58401112,14.4999988 1.5,14.4159841 1.5,14.3124993 L1.5,3.68752459 C1.5,3.58403973 1.58401112,3.50002861 1.68749598,3.50002861 L6.4999845,3.50002861 C6.77598482,3.50002861 6.99998331,3.27602654 6.99998331,3.00002861 L6.99998331,2.50002861 C6.99998331,2.2240271 6.77598482,2.00002861 6.4999845,2.00002861 L1.5,2.00002861 C0.671995468,2.00002861 0,2.67202408 0,3.50002861 L0,14.4999988 C0,15.3279998 0.671995468,15.9999952 1.5,15.9999952 L12.4999702,15.9999952 Z' id='e' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
            }
        }
        &.show {
            opacity: 1;
        }
        .arrow {
            position: absolute;
            display: block;
            width: ${remCalc(12.8)};
            height: ${remCalc(6.4)};
            &::before {
                position: absolute;
                content: "";
                border-color: transparent;
                border-style: solid;
            }
        }

        .tooltip-inner {
            max-width: ${remCalc(210)};
            padding: ${remCalc(10)} ${remCalc(16)} ${remCalc(12)};
            color: ${props => props.theme.colors.brilliant};
            text-align: center;
            background-color: ${props => props.theme.colors.accent8};
            border-radius: ${props => props.theme.radius};
        }

        &.bs-tooltip-top,
        &.bs-tooltip-auto[x-placement^="top"] {
            padding: ${remCalc(6.4)} 0;
            .arrow {
                bottom: 0;
                &::before {
                    top: 0;
                    border-width: ${remCalc(6.4)} (${remCalc(12.8)} / 2) 0;
                    border-top-color: ${props => props.theme.colors.accent8};
                }
            }
        }

        &.bs-tooltip-right,
        &.bs-tooltip-auto[x-placement^="right"] {
            padding: 0 ${remCalc(6.4)};
            .arrow {
                left: 0;
                width: ${remCalc(6.4)};
                height: ${remCalc(12.8)};
                &::before {
                    right: 0;
                    border-width: (${remCalc(12.8)} / 2) ${remCalc(6.4)}
                        (${remCalc(12.8)} / 2) 0;
                    border-right-color: ${props => props.theme.colors.accent8};
                }
            }
        }

        &.bs-tooltip-bottom,
        &.bs-tooltip-auto[x-placement^="bottom"] {
            padding: ${remCalc(6.4)} 0;
            .arrow {
                top: 0;
                &::before {
                    bottom: 0;
                    border-width: 0 (${remCalc(12.8)} / 2) ${remCalc(6.4)};
                    border-bottom-color: ${props => props.theme.colors.accent8};
                }
            }
        }

        &.bs-tooltip-left,
        &.bs-tooltip-auto[x-placement^="left"] {
            padding: 0 ${remCalc(6.4)};
            .arrow {
                right: 0;
                width: ${remCalc(6.4)};
                height: ${remCalc(12.8)};
                &::before {
                    left: 0;
                    border-width: (${remCalc(12.8)} / 2) 0
                        (${remCalc(12.8)} / 2) ${remCalc(6.4)};
                    border-left-color: ${props => props.theme.colors.accent8};
                }
            }
        }
    }
`;
StyledTooltip.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

export { StyledBoiTooltip, StyledTooltip };
